export const SHOW = 'common/menu/SHOW';
export const SHOWN = 'common/menu/SHOWN';

export default function reducer(state = { show: false }, action = {}) {
  switch (action.type) {
    case SHOW:
      return {
        ...state,
        show: true
      }; 
    case SHOWN:
      return {
        ...state,
        show: false
      };           
    default:
      return state;
  }
}

export function showMenu() {
  return {
    type: SHOW
  };
}

export function shownMenu() {
    return {
      type: SHOWN
    };
  }



// WEBPACK FOOTER //
// ./modules/Common/reducers/menu.js